// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82bce153","488":"7599a3e7","553":"18959384"}[chunkId] + ".chunk.js";
};